export enum WidgetType {
  FOLLOW = 'FOLLOW',
  TWEET = 'TWEET',
}

export const WIDGET_TYPE_MAP: Record<WidgetType, string> = {
  FOLLOW: 'follow_button',
  TWEET: 'tweet_button',
};
